import React, { useState } from 'react';

interface SaveButtonProps {
	id: number; // Entity ID (e.g., post ID)
	isSaved: boolean; // Initial saved state
	title: string; // Post title
}

const SaveButton: React.FC<SaveButtonProps> = ({ id, isSaved, title }) => {
	const [saved, setSaved] = useState(isSaved);
	const [loading, setLoading] = useState(false);

	const handleSave = async () => {
		if (loading) return; // Prevent multiple clicks
		setLoading(true);

		try {
			const response = await fetch(`/wp-json/sageverse/v1/save-post`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-WP-Nonce': window.sageverseData.nonce,
				},
				body: JSON.stringify({
					// eslint-disable-next-line camelcase
					post_id: id,
				}),
			});

			const data = await response.json();
			if (data.success) {
				setSaved(data.is_saved);
			} else {
				// eslint-disable-next-line no-console
				console.error(`Failed to save post: ${data.message}`);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(`Error saving post`, error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<button
			className={`save-button ${saved ? 'save-button--is-saved' : ''}`}
			onClick={handleSave}
			aria-label={saved ? `Unsave post ` : `Save post ` + title}
			disabled={loading}
		>
			<span className="save-button__text">{saved ? 'Saved' : 'Save'}</span>
			<span className="icon-save"></span>
			<span className="icon-saved"></span>
		</button>
	);
};

export default SaveButton;
